import { render, staticRenderFns } from "./highQuality_merchant.vue?vue&type=template&id=19f45fbe&scoped=true&"
import script from "./highQuality_merchant.vue?vue&type=script&lang=ts&"
export * from "./highQuality_merchant.vue?vue&type=script&lang=ts&"
import style0 from "./highQuality_merchant.vue?vue&type=style&index=0&id=19f45fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f45fbe",
  null
  
)

export default component.exports